const MODULE_NAME = 'FEATURE_FLAGS_CONTROLLER';

const namespaced = (name) => MODULE_NAME + '.' + name;
const LOAD_FEATURE_FLAGS = namespaced('LOAD_FEATURE_FLAGS');

const ACTION_TYPES = {
    LOAD_FEATURE_FLAGS,
}

const updateSubStateFromAction = (state = { data: undefined }, action) => {
    return action.type === LOAD_FEATURE_FLAGS ? { ...state, data: action.payload, loaded: true } : state;
}

export {
    MODULE_NAME,
    ACTION_TYPES,
    updateSubStateFromAction
}